<template>
    <div class="bulk-purchase text-normal">
        <hero-section @registerScrollRefs="registerScrollableRefs" />
        <media-reviews />
        <nzxt-bld-services @scrollToRef="scrollToRef" />
    </div>
</template>
<script>
import HeroSection from "./hero-section.vue";
import MediaReviews from "./media-reviews.vue";
import NzxtBldServices from "./nzxt-bld-services.vue";

export default {
    name: "BulkPurchase",
    components: {
        HeroSection,
        MediaReviews,
        NzxtBldServices
    },
    data() {
        return {
            scrollableRefs: new Map()
        }
    },
    methods: {
        registerScrollableRefs(refsCollection) {
            for(const refItem of refsCollection) {
                if(this.scrollableRefs.has(refItem.name)) {
                    continue;
                }
                this.scrollableRefs.set(refItem.name, refItem.el);
            }
        },
        scrollToRef(refName) {
            const refToScroll = this.scrollableRefs.get(refName);
            this.$scrollTo(refToScroll, 300, {
                offset: -88
            });
        }
    }
}
</script>
<style lang="scss">
/* Global CSS for Bulk Purchase */
.bulk-purchase .request-builds-btn {
    background-color: #51007A;
    color: var(--white);
    letter-spacing: 0;

    &:hover {
        background-color: transparent;
        color: #51007A;
        border-color: #51007A;
    }
}
</style>
<style lang="scss" scoped>
@import "~@s/_asset-mixers.scss";

/* MOBILE */
.font-14 {
    font-size: 14px;
}

.bulk-purchase {
    font-family: "Akkurat-normal", sans-serif;
    background-color: $white;
    border-color: $sub-grey;
    font-size: 16px;
}

/* TABLET */
@media screen and (min-width: 768px) {
    .bulk-purchase br {
        display: none;
    }
}
/* TABLET & DESKTOP */
@media screen and (min-width: 1024px) {
    .bulk-purchase br {
        display: initial;
    }
}
</style>